import axios from 'axios';

export const getUserInfo = async (upn) => {
  try {
    const response = await axios.post('https://prod-248.westeurope.logic.azure.com:443/workflows/d974b589155b46f2a02684cb2ce27ee4/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=pQ6wNworZrV00LSTim7GfnVXB5bhl8g9_qKLyLXVbKc', {
      upn 
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des informations utilisateur:', error);
    throw error;
  }
}; 